import { createSelector } from "reselect";
import { segmentsSelector } from "./segments";

export const selectTransUnits = (state) => state.file;
export const selectUploadModel = (state) => state.uploadModel;
export const selectLanguages = (state) => state.languages;
export const selectMTmodel = (state) => state.model.modelMT;
export const selectMachineTranslation = (state) => state.translation;
export const selectCurrentStep = (state) => state.stateMng.activeStep;
export const selectModalReturnState = (state) => state.stateMng.showReturnDialog;
export const selectSegments = (state) => state.segments.segments;
export const selectSegmentState = (state) => state.segments;
export const selectDialogState = (state) => state.stateMng.showReturnDialog;
export const selectSvr = (state) => state.validation;
export const selectOpenEditorTargetId = (state) => state.opendEditorTargetId.targetId;
export const selectAnimationClass = (state) => state.stateMng.animationClass;
export const selectAnnonymously = (state) => state.stateMng.annonymously;
//export const selectAllSegments = segmentsSelector.selectAll(state => state.segments);

//export const getAll = createSelector(selectAllSegments);
export const getAnnonymously = createSelector(selectAnnonymously, (annon) => annon);
export const getAnimation = createSelector(selectAnimationClass, (animation) => animation);
export const getSegmentState = createSelector(selectSegmentState, (loading) => loading);
export const getModalSate = createSelector(selectModalReturnState, (modal) => modal);

export const getSvrById = (targetId) => createSelector(selectSvr, (validation) => validation.filter((svr) => svr.segmentId === targetId));

export const getOpenEditorTargetId = createSelector(selectOpenEditorTargetId, (targetId) => targetId);

export const getSvr = createSelector(selectSvr, (svr) => svr);

export const getSegments = createSelector(selectSegments, (segments) => segments);

export const getCurrentStep = createSelector(selectCurrentStep, (stepperState) => stepperState);

export const getTransUnits = createSelector(selectTransUnits, (file) => file);

export const getMachineTranslationModel = createSelector(selectMTmodel, (modelMT) => modelMT);

export const getMachineTranslation = createSelector(selectMachineTranslation, (translation) => translation);

export const getLanguages = createSelector(selectLanguages, (languages) => languages);

export const getUploadFileModel = createSelector(selectUploadModel, (uploadModel) => uploadModel);

export const getRerurnDialog = createSelector(selectDialogState, (showReturnDialog) => showReturnDialog);
